import { useTranslation } from "react-i18next";
import "./App.css";
import CustomButton from "./components/сustomButton";
import ContentBox from "./components/contentBox";
import OfferContainer from "./components/offerContainer";
import ContactForm from "./components/contactForm";
import NavigationBar from "./components/navigationBar";
import IphonePlayer from "./components/iphoneVideoplayer";

function App() {
  const { t } = useTranslation();

  const scrollToContactForm = () => {
    const element = document.getElementById("contactForm");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className=" flex flex-col justify-center items-center m-2 md:m-10">
      {/* <MetaPixel /> */}
      <NavigationBar t={t} scrollToContactForm={scrollToContactForm} />
      {/* First block */}
      <section className="relative w-full min-h-screen pt-3 md:pt-0">
        {/* Фоновый паттерн с фиксированной шириной 1920px */}
        <div className="absolute inset-0 w-full overflow-hidden flex justify-center z-0">
          <img
            className="min-w-[1920px] w-full h-auto object-cover absolute bottom-0"
            src="/images/pattern.svg"
            alt="Background Pattern"
          />
        </div>

        {/* Контейнер для контента */}
        <div className="relative w-full h-full max-w-[1920px] container z-10 min-h-screen flex items-center">
          <div className="w-full h-auto gap-10 md:gap-20 flex flex-col items-center  max-w-[1440px] justify-between mx-auto">
            <text className="font-spaceGrotesk text-3xl md:text-6xl text-center  pt-5 md:pt-0">
              {t("title1")}
            </text>

            <div className="w-full flex flex-col md:flex-row items-center justify-between gap-4">
              {/* Левое изображение - равной высоты с iPhone */}
              <div className=" w-auto  relative">
                <img
                  className="w-full h-full object-contain"
                  src="/images/childArt.webp"
                  alt="Child Art"
                />
              </div>

              {/* Стрелка - скрывается на мобильных устройствах */}
              <img
                className="md:block w-16 h-auto transform rotate-90 md:rotate-0"
                src="/images/arrow.webp"
                alt="Arrow"
              />

              {/* IphonePlayer - равной высоты с изображением */}
              <div className="w-auto md:w-5/12 relative">
                <IphonePlayer videoUrl="https://r2.little-art-games.com/0309.mp4" />
              </div>
            </div>

            <CustomButton
              text={t("contact_us")}
              onClick={scrollToContactForm}
              className=" bg-[#FF8006] rounded-lg px-3 py-2 text-white"
            />
          </div>

          {/* <img className="w-full z-10" src="/images/blueLine.svg" /> */}
        </div>
      </section>
      {/* Second block */}
      <section className=" w-full h-full max-w-[1920px] justify-center items-center mt-9 container">
        <div className=" flex flex-row flex-wrap gap-10">
          <text className=" custom-title-with-bg text-xl md:text-4xl">
            {t("section2_title")}
          </text>
          <text className=" font-spaceGrotesk text-lg text-black max-w-[700px]">
            {t("section2_title_info")}
          </text>
        </div>
        <div
          className=" grid grid-cols-1 md:grid-cols-2 w-full py-8 gap-4"
          id="about"
        >
          <ContentBox
            title={t("benefit1_title")}
            text={t("benefit1_text")}
            image={"/images/benefitsImages/fast.webp"}
          />
          <ContentBox
            title={t("benefit2_title")}
            text={t("benefit2_text")}
            image={"/images/benefitsImages/gift.webp"}
            color="blue"
          />
          <ContentBox
            title={t("benefit3_title")}
            text={t("benefit3_text")}
            image={"/images/benefitsImages/family.webp"}
            color="black"
          />
          <ContentBox
            title={t("benefit4_title")}
            text={t("benefit4_text")}
            image={"/images/benefitsImages/cross-platform.webp"}
          />
        </div>
        {/* Get persinal offer  */}
        <div className=" flex justify-center items-center w-full">
          <div className=" flex flex-col md:flex-row bg-[#F3F3F3] p-6 lg:p-14 rounded-2xl justify-between w-full max-w-[1230px]">
            <div className=" flex flex-col max-w-[500px] gap-7 justify-between">
              <span className=" font-spaceGrotesk text-3xl">
                {t("personal_offer_card_title")}
              </span>
              <span className=" font-spaceGrotesk text-lg">
                {t("personal_offer_card_text")}
              </span>
              <CustomButton
                text={t("contact_us")}
                onClick={scrollToContactForm}
              />
            </div>
            <img
              className=" p-9 h-80"
              src="/images/customer-service.svg"
              alt="customer service icon"
            />
          </div>
        </div>
      </section>
      <section
        className=" w-full h-full max-w-[1440px] mt-9 container"
        id="pricing"
      >
        <div className=" flex flex-row flex-wrap gap-10">
          <text className=" custom-title-with-bg text-xl md:text-4xl">
            {t("section3_title")}
          </text>
          <text className=" font-spaceGrotesk text-lg text-black max-w-[499px]">
            {t("section3_title_info")}
          </text>
        </div>
        <div className=" flex flex-row flex-wrap my-8 gap-4 justify-center">
          <OfferContainer
            title={t("offer1_title")}
            text1={t("offer1_text1")}
            text2={t("offer1_text2")}
            textPrice={`${t("offer_price")} 1000$`}
          />
          <OfferContainer
            title={t("offer2_title")}
            text1={t("offer2_text1")}
            text2={t("offer2_text2")}
            textPrice={`${t("offer_price")} 2000$`}
            color="blue"
          />
          <OfferContainer
            title={t("offer3_title")}
            text1={t("offer3_text1")}
            text2={t("offer3_text2")}
            textPrice={`${t("offer_price")} 3000$`}
            color="black"
          />
        </div>
      </section>
      <section
        className="w-full h-full max-w-[1440px] mt-9 container"
        id="contactForm"
      >
        <div className=" flex flex-row flex-wrap gap-10">
          <text className=" custom-title-with-bg text-xl md:text-4xl">
            {t("section4_title")}
          </text>
          <text className=" font-spaceGrotesk text-lg text-black max-w-[499px]">
            {t("section4_title_info")}
          </text>
        </div>
        <div className=" flex flex-col-reverse lg:grid lg:grid-cols-2 bg-gray-100 px-6 py-4 lg:px-12 lg:py-8 my-4 rounded-3xl justify-center items-center">
          <ContactForm t={t} />
          <div className=" w-full h-full flex justify-center items-center p-8">
            <img
              src="/images/email.webp"
              className=" w-40 lg:w-80"
              alt=" email icon"
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
